module.exports = __webpack_public_path__ + "img/bird-13-left.4c13da8c.png";